import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 px-4 bg-light-sage" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-[2rem] shadow-warm" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-sage" data-id="element-93">
            Sé cómo se siente.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-espresso/90" data-id="element-94">
            <p data-id="element-95">
              Te levantas con los dedos rígidos, una pesadez en el vientre que
              no te deja ni abrocharte bien el pantalón, y ese cansancio que te
              dan ganas de volver a la cama a las 10 de la mañana.
            </p>
            <p data-id="element-96">
              Vas al médico aquí en Estados Unidos y te dicen que "es la edad" o
              que tienes que comer ensaladas sosas, avena de caja y pollo
              hervido. Sientes que para estar sana tienes que dejar de ser
              latina. Sientes que te roban tus costumbres.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}